/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const mediaSchema = z.object({
  id: z.number(),
  path: z.string(),
  filename: z.string().nullable(),
  contentType: z.string().nullable(),
  width: z.number().nullable(),
  height: z.number().nullable(),
  size: z.number().nullable(),
  url: z.string().nullable(),
  createdBy: z.string().nullable(),
  createdAt: z.number(),
});

export type IMedia = z.infer<typeof mediaSchema>;
